import * as React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { clearErrorMessage } from 'slices/usersSlice'
import { selectWorkspacesStatus, deleteWorkspace } from 'slices/workspacesSlice'

import { CustomModal } from 'components/common'

type Props = {
  isOpen: boolean
  workspaceId: number
  onSuccess: () => void
  onCancel: () => void
}

const WorkspaceDelete: React.FC<Props> = ({ isOpen, workspaceId, onSuccess, onCancel }) => {
  const [modalErrorMessage, setModalErrorMessage] = React.useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = React.useState(false)
  const { isRequesting, errorMessage } = useSelector(selectWorkspacesStatus, shallowEqual)
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (!submitted || isRequesting) {
      return
    }
    if (errorMessage === '') {
      onSuccess()
    } else {
      setModalErrorMessage('削除できませんでした。')
      dispatch(clearErrorMessage())
    }
    setSubmitted(false)
  }, [submitted, isRequesting, errorMessage, onSuccess, dispatch])

  const onCancelClick = () => {
    setModalErrorMessage(undefined)
    setSubmitted(false)
    onCancel()
  }

  const onDeleteClick = () => {
    setSubmitted(true)
    dispatch(deleteWorkspace(workspaceId))
  }

  return (
    <CustomModal
      isOpen={isOpen}
      title="ワークスペースの削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={onCancelClick}
      onApprove={onDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">このワークスペースを本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default WorkspaceDelete
